import Filters from './component';
import { FiltersProps } from './types';

export default Filters;
export type { FiltersProps };
